import { DynamicAttributeEntity } from "gql/graphql";
import { FieldsType } from "./model/types";
import { useSaveEnumDynamicAttribute } from "./model/use-save-enum-dynamic-attribute";
import { EnumDynamicAttributeForm } from "./ui/enum-dynamic-attribute-form";

export function SaveEnumDynamicAttribute({
  groupId,
  dynamicAttributeEntity,
  category,
  afterSubmit,
  initialValues,
}: {
  groupId?: string;
  dynamicAttributeEntity: DynamicAttributeEntity;
  category?: string;
  afterSubmit?: () => void;
  initialValues?: FieldsType;
}) {
  const { save, loading } = useSaveEnumDynamicAttribute({ afterSubmit });

  return (
    <EnumDynamicAttributeForm
      initialValues={
        {
          group: groupId,
          dynamicAttributeEntity,
          category,
          ...initialValues,
        } as FieldsType
      }
      onFinish={save}
      disabled={loading}
    />
  );
}
